import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import InputText from '../../../../common/components/ui/InputText';
import styles from './FieldCustomerAddress.module.scss';

const FieldCustomerAddress = () => {
  const intl = useIntl();
  const labelText = intl.formatMessage({
    id: 'payment-form-customerAddress',
    defaultMessage: `Customer's address`
  });
  const defaultPlaceholder = intl.formatMessage({
    id: 'default-placeholder',
    defaultMessage: 'Write here'
  });
  const [field, meta] = useField<string>({name: 'customerAddress'});

  return (
    <InputText
      {...field}
      {...meta}
      variant={'full'}
      id={field.name}
      label={
        <div className={styles.labelContainer}>
          <span>{labelText}</span>
        </div>
      }
      placeholder={defaultPlaceholder}
      defaultValue={field.value}
    />
  );
};

export default FieldCustomerAddress;
